import { ConsultFieldTypeEnum } from 'utils/enums';

const impressionOptions = [
  { value: 'AlteredMentalStatus', label: 'Altered Mental Status' },
  { value: 'BellsPalsy', label: 'Bells Palsy' },
  { value: 'Dissection', label: 'Dissection' },
  { value: 'Encephalopathy', label: 'Encephalopathy' },
  { value: 'GroundLevelFall', label: 'Ground Level Fall' },
  { value: 'GuillainBarre', label: 'Guillain Barre' },
  { value: 'Headache', label: 'Headache' },
  { value: 'Imbalance', label: 'Imbalance' },
  {
    value: 'IntracerebralHemorrhage',
    label: 'ICH',
    summaryLabel: 'Intracerebral hemorrhage',
  },
  {
    value: 'IntraventricularHemorrhage',
    label: 'IVH',
    summaryLabel: 'Intraventricular hemorrhage',
  },
  { value: 'IschemicStrokeAcute', label: 'Ischemic Stroke (Acute)' },
  { value: 'IschemicStrokeSubacute', label: 'Ischemic Stroke (Subacute)' },
  { value: 'Meningitis', label: 'Meningitis' },
  { value: 'Meningoencephalitis', label: 'Meningoencephalitis' },
  { value: 'Migraine', label: 'Migraine' },
  { value: 'MigraineComplex', label: 'Migraine (Complex)' },
  { value: 'MultipleSclerosis', label: 'Multiple Sclerosis' },
  { value: 'Myelopathy', label: 'Myelopathy' },
  { value: 'NearSyncope', label: 'Near Syncope' },
  { value: 'Radiculopathy', label: 'Radiculopathy' },
  {
    value: 'ReversibleCerebralVasoconstrictionSyndrome',
    label: 'RCVS',
    summaryLabel: 'Reversible Cerebral Vasoconstriction Syndrome',
  },
  { value: 'Seizure', label: 'Seizure' },
  { value: 'SeizureLikeActivity', label: 'Seizure-like Activity' },
  { value: 'StatusEpilepticus', label: 'Status Epilepticus' },
  { value: 'StrokeMimic', label: 'Stroke Mimic' },
  {
    value: 'SubarachnoidHemorrhage',
    label: 'SAH',
    summaryLabel: 'Subarachnoid Hemorrhage',
  },
  {
    value: 'SubduralHematoma',
    label: 'SDH',
    summaryLabel: 'Subdural Hematoma',
  },
  { value: 'Syncope', label: 'Syncope' },
  {
    value: 'TransientIschemicAttack',
    label: 'TIA',
    summaryLabel: 'Transient Ischemic Attack',
  },
  { value: 'ToddsParalysis', label: 'Todds Paralysis' },
  { value: 'TransientGlobalAmnesia', label: 'Transient Global Amnesia' },
  { value: 'Vasculitis', label: 'Vasculitis' },
  {
    value: 'Vertebrobasilar',
    label: 'Vertebro basilar',
    summaryLabel: 'Vertebrobasilar Insufficiency Syndrome',
  },
  { value: 'Vertigo', label: 'Vertigo' },
  { value: 'Weakness', label: 'Weakness' },
  { value: 'Other', label: 'Other' },
];

export const neuroAssessmentFields = {
  impressionPredefined: {
    name: 'impressionPredefined',
    placeholder: '(select one)',
    label: 'Impression',
    required: true,
    type: ConsultFieldTypeEnum.CHIP_SINGLE,
    options: impressionOptions,
  },
  impressionFreeText: {
    name: 'impressionFreeText',
    associatedField: 'impressionPredefined',
    type: ConsultFieldTypeEnum.DICTATION,
    multiline: true,
    rows: 2,
  },
  differentialDiagnosisPredefined: {
    name: 'differentialDiagnosisPredefined',
    label: 'Differential Diagnosis',
    type: ConsultFieldTypeEnum.CHIP,
    options: impressionOptions,
  },
  differentialDiagnosisFreeText: {
    name: 'differentialDiagnosisFreeText',
    associatedField: 'differentialDiagnosisPredefined',
    type: ConsultFieldTypeEnum.DICTATION,
    multiline: true,
    rows: 2,
  },
};


export const clinicAssessmentFields = {
  impressionPredefined: {
    name: 'impressionPredefined',
    placeholder: '(select one)',
    label: 'Impression',
    required: true,
    type: ConsultFieldTypeEnum.CHIP_SINGLE,
    options: impressionOptions,
  },
  impressionFreeText: {
    name: 'impressionFreeText',
    associatedField: 'impressionPredefined',
    type: ConsultFieldTypeEnum.DICTATION,
    multiline: true,
    rows: 2,
  },
  differentialDiagnosisPredefined: {
    name: 'differentialDiagnosisPredefined',
    label: 'Differential Diagnosis',
    type: ConsultFieldTypeEnum.CHIP,
    options: impressionOptions,
  },
  differentialDiagnosisFreeText: {
    name: 'differentialDiagnosisFreeText',
    associatedField: 'differentialDiagnosisPredefined',
    type: ConsultFieldTypeEnum.DICTATION,
    multiline: true,
    rows: 2,
  },
  medicalDecisionMakingHighLevelPredefined: {
    name: 'medicalDecisionMakingHighLevelPredefined',
    label: 'Medical Decision Making (High Level)',
    summaryLabel: 'Medical Decision Making',
    type: ConsultFieldTypeEnum.CHIP,
    options: [
      { value: 'DisabledByCondition', label: 'disabled by condition' },
      { value: 'CannotDrive', label: 'cannot drive' },
      { value: 'NoLongerWorking', label: 'no longer working' },
      { value: 'Manage4PlusDiagnoses', label: 'manage 4+ diagnoses' },
      {
        value: 'NeurologicClearanceForProcedure',
        label: 'neurologic clearance for procedure',
      },
      {
        value: 'PatientHasNewProblemCondition',
        label: 'patient has new problem/condition',
      },
      { value: 'PatientIsNotStable', label: 'patient is not stable' },
    ],
  },
  medicalDecisionMakingModerateLevelPredefined: {
    name: 'medicalDecisionMakingModerateLevelPredefined',
    associatedField: 'medicalDecisionMakingHighLevelPredefined',
    label: 'Medical Decision Making (Moderate Level)',
    type: ConsultFieldTypeEnum.CHIP,
    options: [
      {
        value: 'Manage2ChronicStableConditions',
        label: 'manage 2 chronic/stable conditions',
      },
      {
        value: 'ManageIllnessWithMildExacerbation',
        label: 'manage illness with a mild exacerbation',
      },
      {
        value: 'PatientOnlyPartiallyImprovingResponding',
        label: 'patient is only partially improving/responding',
      },
      {
        value: 'PatientHasPriorComplication',
        label: 'patient has prior complication',
      },
    ],
  },
};
